import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslateService {
  viewPage: boolean = true
  translateItems: any = []
  constructor(private http: HttpClient) { }

  getTranslate() {
    if (this.translateItems.length == 0) {
      // this.http.get(`http://localhost:6114/api/translate`).subscribe({
      //   next: (res: any) => {
      //     this.translateItems = res.data[0]
      //     this.viewPage = true
      //   }
      // })
    }
  }
}
